module.exports = __webpack_public_path__ + "img/first_point_1.73eb53d0.png";